(function () {
  'use strict';

  function initQuiz(root) {
    var sectionId = root.dataset.sectionId;
    var config = (window.pqConfig && window.pqConfig[sectionId]) || {};
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-pq-step]'));
    var resultScreen = root.querySelector('[data-pq-result]');
    var stepsWrapper = root.querySelector('[data-pq-steps]');
var answers = {};
    var currentIndex = 0;

    // NEW: measures the currently-active step's fixed footer height and
    // exposes it as a CSS variable (--pq-footer-height) on the root, so the
    // required-message box (now position: fixed in the CSS) can pin itself
    // exactly above the footer instead of sitting inline in the content
    // flow where it could end up out of view until the user scrolled.
    function updateFooterHeightVar() {
      var activeStep = steps[currentIndex];
      var footer = activeStep && activeStep.querySelector('.pq-step-footer');
      if (footer) {
        root.style.setProperty('--pq-footer-height', footer.offsetHeight + 'px');
      }
    }

    // UPDATED: now listens for the EMBEDDED Klaviyo form's submit event
    // instead of the popup. Same logic — just a different form ID.
    // Replace 'YOUR_EMBED_FORM_ID' below with the ID Klaviyo gives you on
    // the Publish → Embed code tab (looks like a 5-6 char code, same shape
    // as TKSBku was for the popup).
    window.addEventListener('klaviyoForms', function (e) {
      if (!e.detail || e.detail.formId !== 'QXB938') return;
      if (e.detail.type === 'submit' && e.detail.metaData && e.detail.metaData.$email) {
        answers.email = e.detail.metaData.$email;
        submitQuiz();
      }
    });

    function refreshRequiredMessage(el) {
      var step = el.closest('[data-pq-step]');
      if (!step) return;
      var msg = step.querySelector('[data-pq-required-msg]');
      if (msg && !msg.hidden && validateStep(step)) {
        msg.hidden = true;
      }
    }

    root.querySelectorAll('[data-pq-custom-select]').forEach(function (wrap) {
      var trigger = wrap.querySelector('[data-pq-select-trigger]');
      var valueEl = wrap.querySelector('[data-pq-select-value]');
      var list = wrap.querySelector('[data-pq-select-options]');
      var options = wrap.querySelectorAll('.pq-select-option');
      var key = wrap.dataset.answerKey;

      function closeList() {
        list.hidden = true;
        wrap.dataset.open = 'false';
        trigger.setAttribute('aria-expanded', 'false');
      }
      function openList() {
        list.hidden = false;
        wrap.dataset.open = 'true';
        trigger.setAttribute('aria-expanded', 'true');
      }

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (list.hidden) openList(); else closeList();
      });

      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          options.forEach(function (o) { o.classList.remove('pq-selected'); });
          opt.classList.add('pq-selected');
          valueEl.textContent = opt.dataset.value;
          valueEl.classList.remove('pq-placeholder');
          wrap.classList.add('pq-has-value');
          answers[key] = opt.dataset.value;
          closeList();
          wrap.classList.remove('pq-field--error');
          refreshRequiredMessage(wrap);
        });
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) closeList();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeList();
      });
    });

    root.querySelectorAll('select[data-pq-input], input[data-pq-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var key = input.dataset.answerKey;
        if (input.type === 'checkbox') {
          answers[key] = input.checked;
        } else {
          answers[key] = input.value;
        }
        clearError(input.closest('.pq-field'));
        refreshRequiredMessage(input);
      });
    });

    root.querySelectorAll('.pq-grid-select[data-pq-input]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var cell = e.target.closest('.pq-grid-cell');
        if (!cell) return;
        group.querySelectorAll('.pq-grid-cell').forEach(function (c) { c.classList.remove('pq-selected'); });
        cell.classList.add('pq-selected');
        answers[group.dataset.answerKey] = cell.dataset.value;
        refreshRequiredMessage(group);
      });
    });

    root.querySelectorAll('.pq-image-grid[data-pq-input]').forEach(function (grid) {
      var isMulti = grid.dataset.multi === 'true';
      var key = grid.dataset.answerKey;
      if (isMulti) answers[key] = answers[key] || [];

      var step = grid.closest('[data-pq-step]');
      var tipBox = step ? step.querySelector('[data-pq-tip]') : null;
      var tipText = tipBox ? tipBox.querySelector('[data-pq-tip-text]') : null;

      grid.addEventListener('click', function (e) {
        var card = e.target.closest('.pq-image-card');
        if (!card) return;
        var value = card.dataset.value;

        if (isMulti) {
          var list = answers[key] || [];
          if (card.classList.contains('pq-selected')) {
            card.classList.remove('pq-selected');
            list = list.filter(function (v) { return v !== value; });
          } else {
            card.classList.add('pq-selected');
            list.push(value);
          }
          answers[key] = list;
        } else {
          grid.querySelectorAll('.pq-image-card').forEach(function (c) { c.classList.remove('pq-selected'); });
          card.classList.add('pq-selected');
          answers[key] = value;

          var tip = card.dataset.tip;
          if (tipBox && tipText) {
            if (tip) {
              tipText.textContent = tip;
              tipBox.classList.add('pq-tip--visible');
            } else {
              tipBox.classList.remove('pq-tip--visible');
            }
          }
        }
        refreshRequiredMessage(grid);
      });
    });

    root.querySelectorAll('.pq-tabs').forEach(function (tabsEl) {
      var step = tabsEl.closest('[data-pq-step]');
      var panels = step.querySelectorAll('.pq-tab-panel');
      tabsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.pq-tab');
        if (!btn) return;
        var tabName = btn.dataset.pqTab;
        tabsEl.querySelectorAll('.pq-tab').forEach(function (t) { t.classList.remove('pq-tab--active'); });
        btn.classList.add('pq-tab--active');
        panels.forEach(function (p) {
          p.classList.toggle('pq-tab-panel--active', p.dataset.pqTabPanel === tabName);
        });
      });
    });

    root.querySelectorAll('[data-pq-tip-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('[data-pq-tip]').classList.remove('pq-tip--visible');
      });
    });

    function clearError(field) {
      if (field) field.classList.remove('pq-field--error');
    }

    function validateStep(step) {
      if (step.dataset.required === 'false') return true;
      var type = step.dataset.stepType;

      if (type === 'dropdown_step') {
        var wrap = step.querySelector('[data-pq-custom-select]');
        if (wrap && wrap.dataset.selectRequired !== 'false' && !wrap.classList.contains('pq-has-value')) {
          wrap.classList.add('pq-field--error');
          return false;
        }
      }

      if (type === 'tabs_step') {
        // FIX: only check groups inside the currently active tab panel — the
        // previous version checked ALL panels (EU/FR/UK), so it wrongly
        // blocked Next even when the visible tab was fully answered, just
        // because the other (hidden) tabs had nothing selected.
        var activePanel = step.querySelector('.pq-tab-panel--active');
        if (!activePanel) return true;
        var groups = activePanel.querySelectorAll('.pq-grid-select[data-pq-input]');
        var allAnswered = true;
        groups.forEach(function (g) {
          if (!g.querySelector('.pq-grid-cell.pq-selected')) allAnswered = false;
        });
        return allAnswered;
      }

      if (type === 'image_grid_step') {
        // FIX: check this grid's own selected card in the DOM rather than
        // answers[key] — duplicated image_grid_step blocks default to the
        // same answer key ("band_fit"), which previously meant selecting an
        // option on an earlier duplicate step made a later required step
        // think it was already answered. Checking the DOM scopes the check
        // to this exact step, regardless of key collisions.
        var grid = step.querySelector('.pq-image-grid[data-pq-input]');
        return grid ? !!grid.querySelector('.pq-image-card.pq-selected') : true;
      }

      if (type === 'multiselect_step') {
        var mgrid = step.querySelector('.pq-image-grid[data-pq-input]');
        if (!mgrid) return true;
        return mgrid.querySelectorAll('.pq-image-card.pq-selected').length > 0;
      }

      if (type === 'email_step') {
        var input = step.querySelector('input[type="email"][data-pq-input]');
        return input ? !!input.value : true;
      }

      return true;
    }

var KLAVIYO_POPUP_FORM_ID = 'TKSBku';

    function goToStep(index) {
      steps.forEach(function (s, i) {
        s.classList.toggle('pq-step--active', i === index);
      });
      currentIndex = index;

      // NEW: keep --pq-footer-height in sync with whichever step's footer
      // is now visible, so the fixed required-message box (see CSS) always
      // sits the correct distance above it.
      updateFooterHeightVar();

      // // NEW: the moment the visitor reaches the email step, open the
      // // Klaviyo popup form directly (only once — guarded by dataset flag
      // // so it doesn't reopen every time they navigate back and forth).
      // var activeStep = steps[index];
      // if (activeStep && activeStep.dataset.stepType === 'email_step' && !activeStep.dataset.klaviyoOpened) {
      //   window._klOnsite = window._klOnsite || [];
      //   window._klOnsite.push(['openForm', KLAVIYO_POPUP_FORM_ID]);
      //   activeStep.dataset.klaviyoOpened = 'true';
      // }

      root.dispatchEvent(new CustomEvent('pq:stepchange', { detail: { index: index } }));
    }

    root.querySelectorAll('[data-pq-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.closest('[data-pq-step]');
        var msg = step.querySelector('[data-pq-required-msg]');

        if (!validateStep(step)) {
          if (msg) msg.hidden = false;
          return;
        }
        if (msg) msg.hidden = true;

        if (currentIndex === steps.length - 1) {
          submitQuiz();
        } else {
          goToStep(currentIndex + 1);
        }
      });
    });

    root.querySelectorAll('[data-pq-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (currentIndex > 0) goToStep(currentIndex - 1);
      });
    });

    root.querySelectorAll('[data-pq-restart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        resultScreen.hidden = true;
        stepsWrapper.hidden = false;
        goToStep(0);
      });
    });

    // FIX: the result screen's header back-arrow previously shared the same
    // "restart" handler as the Retake quiz button, so it wrongly reset all
    // the way to step 1. It should instead just return to the last question
    // (the step the visitor was on right before finishing) — all earlier
    // selections are preserved since the step DOM/answers were never cleared.
    root.querySelectorAll('[data-pq-back-to-quiz]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        resultScreen.hidden = true;
        stepsWrapper.hidden = false;
        goToStep(steps.length - 1);
      });
    });

    root.querySelectorAll('[data-pq-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.closest('.pq-modal-overlay') ? root.closest('.pq-modal-overlay').remove() : root.scrollIntoView({ behavior: 'smooth' });
      });
    });

    function submitQuiz() {
      if (answers.email) {
        saveEmailAnswer(answers.email, !!answers.newsletter_opt_in);
      }

      var band = answers[config.sizeAnswerKeys.band] || '';
      var cup = answers[config.sizeAnswerKeys.cup] || '';

      // If a Results page URL is set in the section settings, navigate there
      // (real page load) with every collected answer passed as a query
      // param, instead of showing the result screen inline on this page.
      if (config.resultsPageUrl) {
        var params = new URLSearchParams();
        Object.keys(answers).forEach(function (key) {
          var val = answers[key];
          if (Array.isArray(val)) {
            val.forEach(function (v) { params.append(key, v); });
          } else if (val !== '' && val != null) {
            params.append(key, val);
          }
        });
        var sep = config.resultsPageUrl.indexOf('?') === -1 ? '?' : '&';
        window.location.href = config.resultsPageUrl + sep + params.toString();
        return;
      }

      // Fallback: no results page configured — keep the existing inline
      // result screen behavior on this same page.
      var sizeLabel = (band + cup) || '—';
      stepsWrapper.hidden = true;
      resultScreen.hidden = false;
      var badge = resultScreen.querySelector('[data-pq-size-badge]');
      if (badge) badge.textContent = sizeLabel;

      fetchMatchingProducts(band, cup);
    }

   function saveEmailAnswer(email, optIn) {
      // NOTE: Klaviyo list signup is now handled directly by the popup form
      // itself (KLAVIYO_POPUP_FORM_ID) — no separate API call needed here.

      // UNCHANGED: this still saves the visitor as a Shopify Customer via
      // the native customer form — exactly as before.
      var form = document.getElementById('PQNewsletterForm-' + sectionId);
      if (form) {
        form.querySelector('[data-pq-newsletter-email]').value = email;
        // CHANGE: always subscribe when an email is entered, regardless of
        // the checkbox — filling in the email step itself now counts as
        // newsletter consent, so accepts_marketing is always "true" here.
        form.querySelector('[data-pq-newsletter-marketing]').value = 'true';
        form.submit();
      }

      // NEW: also actually email the visitor their result via EmailJS —
      // Shopify's storefront has no built-in way to send a custom email, so
      // this requires a free EmailJS account (see section settings info
      // text). Only fires if the merchant filled in all 3 EmailJS fields.
      if (config.sendResultEmail && config.emailjsServiceId && config.emailjsTemplateId && config.emailjsPublicKey) {
        var band = answers[config.sizeAnswerKeys.band] || '';
        var cup = answers[config.sizeAnswerKeys.cup] || '';
        var sizeLabel = (band + cup) || '—';

        fetch('https://api.emailjs.com/api/v1.0/email/send', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            service_id: config.emailjsServiceId,
            template_id: config.emailjsTemplateId,
            user_id: config.emailjsPublicKey,
            template_params: {
              to_email: email,
              size: sizeLabel,
              band: band,
              cup: cup,
              shop_name: document.title,
              shop_url: window.location.origin
            }
          })
        }).catch(function () {
          // Silent fail — email delivery is a nice-to-have on top of the
          // Customer save above, which already succeeded regardless.
        });
      }
    }
/* ============================
   KLAVIYO TRACKING
============================= */

function sendQuizToKlaviyo(email, band, cup, products, resultUrl) {

  if (!window._learnq) {
    console.warn("Klaviyo is not loaded.");
    return;
  }

 var productData = products.map(function (product) {
    var productUrl = window.location.origin + "/products/" + product.handle;
    if (product._matchedVariantId) {
      productUrl += "?variant=" + product._matchedVariantId;
    }
    return {
      title: product.title,
      handle: product.handle,
      image: (product.images && product.images.length)
        ? product.images[0].src
        : "",
      url: productUrl
    };
  });

  _learnq.push([
    "identify",
    {
      "$email": email,
      "Bra Size": band + cup
    }
  ]);

  _learnq.push([
    "track",
    "Bra Quiz Completed",
    {
      bra_size: band + cup,
      recommended_products: productData,
      quiz_result_url: resultUrl
    }
  ]);

  console.log("Sent to Klaviyo", productData);

}
    function fetchMatchingProducts(band, cup) {
      var grid = resultScreen.querySelector('[data-pq-product-grid]');
      var loading = grid.querySelector('[data-pq-loading]');

      // Build the required key -> value pairs once — used as tags OR as
      // metafield key/value pairs depending on the matching mode.
      var requiredFields = {};
      if (band) requiredFields[config.sizeAnswerKeys.band] = String(band);
      if (cup) requiredFields[config.sizeAnswerKeys.cup] = String(cup);
      (config.tagAnswerKeys || []).forEach(function (key) {
        var val = answers[key];
        if (!val) return;
        requiredFields[key] = Array.isArray(val) ? val.map(String) : String(val);
      });
      // Step 11 - Bra Type (Padded / Unpadded / T-Shirt Bra)
if (answers.bra_type) {
    requiredFields.bra_type = answers.bra_type;
}

    if (config.filterMode === 'metafields') {
        fetchMatchingProductsByMetafields(requiredFields, band, cup, grid, loading);
      } else if (config.filterMode === 'variants') {
        fetchMatchingProductsByVariants(band, cup, grid, loading);
      } else {
        fetchMatchingProductsByTags(requiredFields, band, cup, grid, loading);
      }
    }

    // ---- Variant-based matching ----
    // Matches against each product's actual "Size" variant option
    // (e.g. "10D" as shown in Shopify admin under Variants), instead of
    // tags or metafields. No extra setup needed on your products — this
    // reads whatever size values already exist on each variant.
    function fetchMatchingProductsByVariants(band, cup, grid, loading) {
      var targetSize = (String(band) + String(cup)).toLowerCase().replace(/\s+/g, '');

      var url = config.collectionHandle
        ? '/collections/' + config.collectionHandle + '/products.json?limit=250'
        : '/products.json?limit=250';

      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = data.products || [];

        var matches = products.filter(function (p) {
            var sizeOptionIndex = -1;
            (p.options || []).forEach(function (opt, idx) {
              if (opt.name && opt.name.toLowerCase().indexOf('size') !== -1) {
                sizeOptionIndex = idx;
              }
            });
            if (sizeOptionIndex === -1) return false;

            var optionKey = 'option' + (sizeOptionIndex + 1);

            // NEW: remember which exact variant matched (its id), so the
            // product link can pre-select this size on the product page.
            var matchedVariant = (p.variants || []).find(function (v) {
              var val = (v[optionKey] || '').toLowerCase().replace(/\s+/g, '');
              return val === targetSize;
            });

            if (matchedVariant) {
              p._matchedVariantId = matchedVariant.id;
              return true;
            }
            return false;
          });

          var recommendedProducts = matches.slice(0, config.maxProducts || 4);
          renderProducts(recommendedProducts, grid, loading);

          if (answers.email) {
            var resultUrl = window.location.origin + window.location.pathname +
              '?' + config.sizeAnswerKeys.band + '=' + encodeURIComponent(band) +
              '&' + config.sizeAnswerKeys.cup + '=' + encodeURIComponent(cup);
            sendQuizToKlaviyo(
                answers.email,
                band,
                cup,
                recommendedProducts,
                resultUrl
            );
          }
        })
        .catch(function () {
          if (loading) loading.textContent = 'We could not load recommendations right now.';
        });
    }

    function fetchMatchingProductsByTags(requiredFields, band, cup, grid, loading) {
      var requiredTags = [];
      // FIX: your products are tagged with band+cup MERGED as one tag
      // (e.g. "34C"), not as two separate tags ("34" and "C"). Build the
      // combined size tag to match that convention.
      if (band && cup) {
        requiredTags.push(String(band) + String(cup));
      } else if (band) {
        requiredTags.push(String(band));
      } else if (cup) {
        requiredTags.push(String(cup));
      }

      var sizeKeys = [config.sizeAnswerKeys.band, config.sizeAnswerKeys.cup];
      Object.keys(requiredFields).forEach(function (key) {
        if (sizeKeys.indexOf(key) !== -1) return; // already folded into the merged size tag above
        var val = requiredFields[key];
        requiredTags = requiredTags.concat(Array.isArray(val) ? val : [val]);
      });

      var url = config.collectionHandle
        ? '/collections/' + config.collectionHandle + '/products.json?limit=250'
        : '/products.json?limit=250';

      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = data.products || [];
          var matches = filterByTags(products, requiredTags);

          if (matches.length === 0 && requiredTags.length > 1 && band && cup) {
            matches = filterByTags(products, [String(band) + String(cup)]);
          }

var recommendedProducts = matches.slice(0, config.maxProducts || 4);

renderProducts(recommendedProducts, grid, loading);

// Send quiz result to Klaviyo
// Send quiz result to Klaviyo
if (answers.email) {
    var resultUrl = window.location.origin + window.location.pathname +
      '?' + config.sizeAnswerKeys.band + '=' + encodeURIComponent(band) +
      '&' + config.sizeAnswerKeys.cup + '=' + encodeURIComponent(cup);
    sendQuizToKlaviyo(
        answers.email,
        band,
        cup,
        recommendedProducts,
        resultUrl
    );
}        })
        .catch(function () {
          if (loading) loading.textContent = 'We could not load recommendations right now.';
        });
    }

    // ---- Metafield matching (Shopify Storefront API / GraphQL) ----
    // ---- Metafield matching (Shopify Storefront API / GraphQL) ----
    // The public REST /products.json endpoint used for tag-matching does NOT
    // expose metafields at all, so metafield matching has to go through the
    // Storefront API instead, which requires a public Storefront access
    // token (safe to expose client-side — that's what it's for).
    function fetchMatchingProductsByMetafields(requiredFields, band, cup, grid, loading) {
      if (!config.storefrontAccessToken) {
        if (loading) loading.textContent = 'Metafield matching requires a Storefront API access token in the section settings.';
        return;
      }

      var namespace = config.metafieldNamespace || 'custom';
      var keys = Object.keys(requiredFields);
      var identifiers = keys.map(function (key) {
        return '{namespace:' + JSON.stringify(namespace) + ',key:' + JSON.stringify(key) + '}';
      }).join(',');

      var query = config.collectionHandle
        ? 'query { collectionByHandle(handle: ' + JSON.stringify(config.collectionHandle) + ') { products(first: 250) { edges { node { ' + productFields(identifiers) + ' } } } } }'
        : 'query { products(first: 250) { edges { node { ' + productFields(identifiers) + ' } } } }';

      function productFields(ids) {
        return 'id title handle images(first: 1) { edges { node { url } } } ' +
          'variants(first: 1) { edges { node { title selectedOptions { name value } } } } ' +
          'metafields(identifiers: [' + ids + ']) { key value }';
      }

      fetch('/api/2024-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': config.storefrontAccessToken
        },
        body: JSON.stringify({ query: query })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var edges = config.collectionHandle
            ? ((data.data && data.data.collectionByHandle && data.data.collectionByHandle.products.edges) || [])
            : ((data.data && data.data.products && data.data.products.edges) || []);

          var products = edges.map(normalizeGraphqlProduct);
          var matches = filterByMetafields(products, requiredFields);

          if (matches.length === 0 && keys.length > 2) {
            var relaxed = {};
            if (band) relaxed[config.sizeAnswerKeys.band] = String(band);
            if (cup) relaxed[config.sizeAnswerKeys.cup] = String(cup);
            matches = filterByMetafields(products, relaxed);
          }

var recommendedProducts = matches.slice(0, config.maxProducts || 4);

renderProducts(recommendedProducts, grid, loading);

if (answers.email) {
    var resultUrl = window.location.origin + window.location.pathname +
      '?' + config.sizeAnswerKeys.band + '=' + encodeURIComponent(band) +
      '&' + config.sizeAnswerKeys.cup + '=' + encodeURIComponent(cup);
    sendQuizToKlaviyo(
        answers.email,
        band,
        cup,
        recommendedProducts,
        resultUrl
    );
}        })
        .catch(function () {
          if (loading) loading.textContent = 'We could not load recommendations right now.';
        });
    }

    // Reshape a Storefront API product edge into the same simple shape
    // renderProducts() already expects from the REST /products.json flow.
    function normalizeGraphqlProduct(edge) {
      var node = edge.node;
      var metafieldMap = {};
      (node.metafields || []).forEach(function (mf) {
        if (mf) metafieldMap[mf.key] = mf.value;
      });
      var imageEdge = node.images && node.images.edges && node.images.edges[0];
      var variantEdge = node.variants && node.variants.edges && node.variants.edges[0];
      var colour = '';
      if (variantEdge && variantEdge.node.selectedOptions) {
        var colourOpt = variantEdge.node.selectedOptions.find(function (o) {
          return /colou?r/i.test(o.name);
        });
        colour = colourOpt ? colourOpt.value : (variantEdge.node.selectedOptions[0] || {}).value || '';
      }
      return {
        handle: node.handle,
        title: node.title,
        _metafields: metafieldMap,
        images: imageEdge ? [{ src: imageEdge.node.url }] : [],
        variants: [{ option1: colour }]
      };
    }

    function filterByMetafields(products, requiredFields) {
      var keys = Object.keys(requiredFields);
      if (!keys.length) return products;
      return products.filter(function (p) {
        return keys.every(function (key) {
          var required = requiredFields[key];
          var actual = (p._metafields && p._metafields[key]) || '';
          var actualLower = actual.toLowerCase();
          if (Array.isArray(required)) {
            return required.some(function (r) { return String(r).toLowerCase() === actualLower; });
          }
          return String(required).toLowerCase() === actualLower;
        });
      });
    }

    function filterByTags(products, requiredTags) {
      if (!requiredTags.length) return products;
      var lowerRequired = requiredTags.map(function (t) { return String(t).toLowerCase(); });
      return products.filter(function (p) {
        var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
        return lowerRequired.every(function (t) { return tags.indexOf(t) !== -1; });
      });
    }

    function renderProducts(products, grid, loading) {
      if (loading) loading.remove();
      if (!products.length) {
        grid.innerHTML = '<p class="pq-loading">No exact matches found — try adjusting your answers.</p>';
        return;
      }
      grid.innerHTML = products.map(function (p) {
        var image = (p.images && p.images[0] && p.images[0].src) || '';
        var badge = p.tags && p.tags.indexOf('New') !== -1 ? '<span class="pq-product-badge">New</span>' : '';
        var matchedSize = '';

if (answers[config.sizeAnswerKeys.band] && answers[config.sizeAnswerKeys.cup]) {
    matchedSize =
        answers[config.sizeAnswerKeys.band] +
        answers[config.sizeAnswerKeys.cup];
}
       // NEW: if a matched variant id was captured (variant-based
        // matching mode), link straight to that size using Shopify's
        // native ?variant= param — the theme's own variant picker already
        // reads this and pre-selects it automatically, no other changes
        // needed. Falls back to the plain product URL for tag/metafield
        // matching modes where no specific variant was captured.
        var productUrl = '/products/' + p.handle;
        if (p._matchedVariantId) {
          productUrl += '?variant=' + p._matchedVariantId;
        }

        return (
          '<div class="pq-product-card">' +
            '<a href="' + productUrl + '">' +
              badge +
              '<img src="' + image + '&width=500" alt="' + escapeHtml(p.title) + '" loading="lazy">' +
              '<p class="pq-product-colour">' + escapeHtml(matchedSize) + '</p>' +
              '<p class="pq-product-title">' + escapeHtml(p.title) + '</p>' +
            '</a>' +
          '</div>'
        );
      }).join('');
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    // NEW: keep the required-message offset correct if the viewport is
    // resized (e.g. orientation change) while a step is open.
    window.addEventListener('resize', updateFooterHeightVar);

// NEW: if someone arrives via the "View all bras" email link with their
    // size already in the URL, skip straight to the results screen instead
    // of starting the quiz over from step 1.
    var urlParams = new URLSearchParams(window.location.search);
    var bandParam = urlParams.get(config.sizeAnswerKeys.band);
    var cupParam = urlParams.get(config.sizeAnswerKeys.cup);
    if (bandParam || cupParam) {
      answers[config.sizeAnswerKeys.band] = bandParam || '';
      answers[config.sizeAnswerKeys.cup] = cupParam || '';
      stepsWrapper.hidden = true;
      resultScreen.hidden = false;
      var urlBadge = resultScreen.querySelector('[data-pq-size-badge]');
      if (urlBadge) urlBadge.textContent = ((bandParam || '') + (cupParam || '')) || '—';
      fetchMatchingProducts(bandParam || '', cupParam || '');
    } else {
      goToStep(0);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pq-wrapper').forEach(function (root) {
      try {
        initQuiz(root);
      } catch (err) {
        console.error('[product-quiz] failed to initialize:', err);
      }
    });
  });

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.pq-wrapper');
    if (root) {
      try {
        initQuiz(root);
      } catch (err) {
        console.error('[product-quiz] failed to re-initialize:', err);
      }
    }
  });
})();
